var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.55376 1.26646C7.86221 0.364618 9.13769 0.36462 9.44614 1.26647L10.6319 4.73345C10.7703 5.138 11.1505 5.40983 11.5781 5.40983H15.3018C16.2829 5.40983 16.6773 6.67552 15.8699 7.23283L12.9471 9.2502C12.5785 9.50461 12.424 9.97306 12.5689 10.3968L13.7059 13.7211C14.0179 14.6335 12.9852 15.4155 12.1917 14.8677L9.06799 12.7117C8.72607 12.4757 8.27383 12.4757 7.9319 12.7117L4.80825 14.8677C4.01467 15.4155 2.98196 14.6335 3.29401 13.7211L4.43099 10.3968C4.57593 9.97306 4.42143 9.50461 4.05285 9.2502L1.13003 7.23283C0.32259 6.67552 0.716976 5.40983 1.69807 5.40983H5.42179C5.84935 5.40983 6.22962 5.138 6.36798 4.73345L7.55376 1.26646Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBs);
export default __webpack_public_path__ + "static/media/bs.ebc64cc75aeecb0ec4bf3d84c95503fb.svg";
export { ForwardRef as ReactComponent };